import { render, staticRenderFns } from "./MailComponent.vue?vue&type=template&id=45b9d32b&"
import script from "./MailComponent.vue?vue&type=script&lang=ts&"
export * from "./MailComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MailComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports